import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function DownloadDialog({
  open,
  onClose,
  layer,
  downloadDataset,
}) {
  function handleDownload() {
    downloadDataset(layer.sourceId);
    onClose();
  }
  return (
    <Box>
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: { width: "50%", m: "auto" },
        }}
      >
        <DialogTitle fontSize={20}>Download Dataset</DialogTitle>
        <DialogContent>
          <Box display="flex" flexDirection="column" my={1}>
            <Typography variant="body" fontSize={16} lineHeight={1.5}>
              Downloading the dataset for '{layer.name}' might take a minute or
              two.
            </Typography>
          </Box>
          <DialogActions
            sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}
          >
            <Button onClick={onClose} variant="contained" color="error">
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleDownload}
            >
              Download
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </Box>
  );
}
